<template>
  <div class="task">
    <div class="inner" @click="enter">
        <div class="title">
          <!-- <span>{{ $t('state.t1')}}</span> -->
          <span>{{info.name}}</span>
        </div>
        <TaskProgress :progress="progress"/>
        <div class="detail">
          <span>{{finished}}</span>
          <span>/</span>
          <span>{{info.total}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import TaskProgress from './TaskProgress'
import anime from 'animejs'
export default {
  components: {
    TaskProgress
  },
  props: {
    info: {
      type: Object
    }
  },
  data () {
    return {
      finished: 0
    }
  },
  computed: {
    progress () {
      if (this.info.finished && this.info.total) {
        return Number(this.info.finished) / Number(this.info.total) * 100
      } else {
        return 0
      }
    }
  },
  methods: {
    enter () {
      this.$router.push({ name: 'task', params: { id: this.info.id } })
    },
    countUp () {
      anime({
        targets: this.$data,
        finished: this.info.finished,
        duration: 1000,
        delay: 200,
        round: 1,
        easing: 'easeInCubic'
      })
    }
  },
  mounted () {
    this.countUp()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/color.scss';
.task {
  padding: 1rem;
  .inner {
    cursor: pointer;
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 100%;
    border-radius: 1rem;
    box-shadow: 0 .05rem .25rem rgba(0,0,0,.3);
    transition: box-shadow .3s ease-in;
    .title, .detail {
      padding: 1rem;
      min-width: 10em;
    }
    .title {
      font-size: 1.5rem;
      height: 3em;
    }
    .detail {
      font-size: 1.125rem;
    }
    &:hover {
      box-shadow: 0 .25rem 1rem rgba(0,0,0,.15);
    }
  }
}
</style>
